import { useTranslation } from '../hooks/useTranslation';

function Logout() {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-center h-screen bg-inputbox-color text-white">
            <p className="text-lg font-medium">{t('auth.messages.sessionExpired')}</p><br />
            <p className="text-lg font-medium">{t('auth.messages.pleaseReopen')}</p>
        </div>
    );
}

export default Logout;
